<template>
  <div>
    <van-form :show-error="false" @submit="handleReleaseLeaveWord">
      <van-cell>留言标题（40字内）</van-cell>
      <van-field placeholder="留言标题" v-model="leaveWordSaveDto.title" :rules="rules.title" maxlength="40"/>

      <van-cell>留言详情（300字内）</van-cell>
      <van-field placeholder="留言详情" type="textarea"
                 v-model="leaveWordSaveDto.content"
                 :rows="8"
                 :rules="rules.content"
                 maxlength="300"/>

      <van-cell>上传图片（最多支持上传3张图片）</van-cell>
      <van-field name="uploader">
        <template #input>
          <van-uploader
              v-model="imageList"
              :max-count="3"
              :after-read="handleUploadImage"/>
        </template>
      </van-field>

      <van-cell>回复后是否展示留言</van-cell>
      <van-field name="radio">
        <template #input>
          <van-radio-group v-model="leaveWordSaveDto.display" direction="horizontal">
            <van-radio name="true">展示</van-radio>
            <van-radio name="false">不展示</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <div style="margin:16px">
        <van-button round block type="info" native-type="submit">
          提交
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import LeaveWordSaveDto from "../dto/LeaveWordSaveDto";
import leaveWordService from "../service/leave-word-service";

export default {
  name: "LeaveWord",
  data() {
    return {
      leaveWordSaveDto: new LeaveWordSaveDto(),
      rules: LeaveWordSaveDto.getRules(),
      imageList: []
    }
  },
  methods: {
    /**
     * 发布留言
     */
    async handleReleaseLeaveWord() {
      this.leaveWordSaveDto.setImageUrlByImageList(this.imageList);
      const result = await leaveWordService.releaseLeaveWord(this.leaveWordSaveDto);
      this.$toast(result.msg);
      if (result.isSuccess()) {
        await this.$router.push("mine-list");
      }
    },
    /**
     * 上传图片
     * @param file 待上传图片
     */
    async handleUploadImage(file) {
      //图片上传前
      file.status = 'uploading';
      file.message = '上传中...';
      //上传图片至服务器
      let params = new FormData();
      params.append("file", file.file);
      const result = await leaveWordService.uploadImage(params);
      if (result.isSuccess()) {
        file.status = 'done';
        file.imageUrl = "/file-storages/attachment/" + result.data.storageName;
      } else {
        file.status = 'failed';
        file.message = result.msg;
      }
    }
  }
}
</script>

<style scoped>

</style>